<app-dialog-container
  title="{{ 'copyMenu' | translate }}"
  [isValid]="form.valid"
  (confirmButtonHandler)="save()"
>
  <form [formGroup]="form">
    <div>
      <app-ui-select
        label="{{ 'tenant' | translate }}"
        [control]="form.targetTenantId"
        [options]="allTenants"
        [isMultiple]="false"
        (changeHandler)="onTargetTenantChange()"
      ></app-ui-select>
      <app-ui-select
        *ngIf="!isMaintenanceStandardJobStructure"
        label="{{ 'departments' | translate }}"
        [control]="form.targetDepartmentIds"
        [options]="allDepartments"
        [isMultiple]="true"
      ></app-ui-select>
      <app-ui-slide-toggle
        *ngIf="isRiskAssessment || isTaskOrDrill || isMaintenanceStandardJobStructure"
        label="{{ 'copyEntities' | translate }}"
        [control]="form.copyContent"
      ></app-ui-slide-toggle>
      <ng-container *ngIf="form.copyContent.value && isTaskOrDrill">
        <app-ui-slide-toggle
          label="{{ 'copyHistory' | translate }}"
          [control]="form.includeHistory"
        ></app-ui-slide-toggle>
        <app-ui-slide-toggle
          label="{{ 'anonimize' | translate }}"
          [control]="form.anonimize"
        ></app-ui-slide-toggle>
      </ng-container>
    </div>
  </form>
</app-dialog-container>
